import axios from "axios";

export const API_URL = "https://cd55-2401-4900-1f3f-2979-f5c9-1760-12c7-d3c8.in.ngrok.io/";

const apiService = axios.create({
  baseURL: API_URL,
});

export default apiService;